import { PrismicRichText } from "@prismicio/react";
import React from "react";
import Slider from "react-slick";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

export const QuoteTabs = (props) => {
  const sc = props.slice.primary;

  const quotes = props.slice.items;

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  function NextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick} tabIndex="0">
        <div className="sr-only">Go to next slide</div>
        <i className="fa-solid fa-chevron-right text-grey text-3xl cursor-pointer" />
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick} tabIndex="0">
        <div className="sr-only">Go to previous slide</div>
        <i className="fa-solid fa-chevron-left text-grey text-3xl cursor-pointer" />
      </div>
    );
  }

  const settings = {
    dots: true,
    appendDots: (dots) => (
      <ul aria-label="Slides">
        {dots}
      </ul>
    ),
    customPaging: (index) => {
      let slideNumber = index + 1;
      return (
        <button aria-label={`Slide ${slideNumber}`}></button>
      );
    },
    fade: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 500,
    pauseOnHover: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: "quote-tabs",
  };

  return (
    <section className={"relative z-10 bg-" + sc.background + " " + space}>
      <div className="relative m-auto max-w-4xl w-11/12">
        <Tabs>
          <TabList>
            {quotes.map((tab, index) => {
              return (
                <Tab key={index} className={"font-bold " + tab.theme}>
                  {tab.tab_label}
                </Tab>
              );
            })}
          </TabList>
          <div className="w-auto m-auto md:w-11/12">
            {quotes.map((quote, index) => {
              return (
                <TabPanel key={index}>
                  <Slider className="flex" {...settings}>
                    {quote.quotes.document.data.quote.map((qu, index) => {
                      return (
                        <div key={index}>
                          <div className={"quotey text-" + quote.theme}>
                            <i className="fa-solid fa-quote-left text-4xl md:text-6xl"></i>
                          </div>
                          <div>
                            <PrismicRichText field={qu.content.richText} />
                          </div>
                          <div>
                            <strong className="mt-4 block">{qu.author}</strong>
                            <span className="block text-sm">
                              {qu.author_title}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </TabPanel>
              );
            })}
          </div>
        </Tabs>
      </div>
    </section>
  );
};
